import { useState } from "react";
import { toast } from "sonner";
import { Copy, Radio } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const NfcDialog = ({ loc, onOpenChange }) => {
  const [writing, setWriting] = useState(false);
  const url = loc ? `${window.location.origin}/nfc/${loc.id}` : "";
  const canWrite = typeof window !== "undefined" && "NDEFReader" in window;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch (e) {
      toast.error("Copy blocked by the browser. Select the link and copy it manually.");
    }
  };

  const write = async () => {
    setWriting(true);
    try {
      const ndef = new window.NDEFReader();
      await ndef.write({ records: [{ recordType: "url", data: url }] });
      toast.success("NFC tag written");
    } catch (e) {
      toast.error(`Could not write the tag: ${e.message || e}`);
    } finally {
      setWriting(false);
    }
  };

  return (
    <Dialog open={!!loc} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#161214] border-[#2E252A]" data-testid="nfc-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl">NFC tag · {loc?.name}</DialogTitle></DialogHeader>
        <p className="text-sm text-[#A89F91]">Write this link on the NFC tag placed at this location. Tapping the tag with an iPhone or Android phone opens the list of wines, bar codes and boxes stored there (the cellar code is asked if needed).</p>
        <div className="flex gap-2">
          <code className="flex-1 font-mono text-xs bg-[#0D0A0B] border border-[#2E252A] rounded px-3 py-2.5 text-[#F5F0EB] break-all" data-testid="nfc-url">{url}</code>
          <Button variant="outline" size="icon" onClick={copy} data-testid="nfc-copy-button" aria-label="Copy link"><Copy className="w-4 h-4" /></Button>
        </div>
        {canWrite ? (
          <Button onClick={write} disabled={writing} className="h-12 bg-[#D4AF37] hover:bg-[#E5A93C] text-[#0D0A0B]" data-testid="nfc-write-button">
            <Radio className="w-4 h-4 mr-2" />{writing ? "Hold the tag near the phone…" : "Write to NFC tag now"}
          </Button>
        ) : (
          <p className="text-xs text-[#6E665D]" data-testid="nfc-write-help">To write the tag: on Android open this page in Chrome and a "Write" button appears here; on iPhone copy the link and write it as a URL record with a free app such as "NFC Tools".</p>
        )}
      </DialogContent>
    </Dialog>
  );
};
